const setupRebuildCostInputEvents = () => {
  $(".js-tpd-question .edit-button button").on("click", function (e) {
    e.preventDefault();
    const $question = $(this).parents("[data-question]");
    const $input = $question.find(".js-rebuild-cost-input");

    $question.find(".js-tpd-question").hide();
    $input.val("").change();
    $question.find(".js-tpd-question-manual").show();
    $input.focus();
  });

  $(".js-rebuild-cost-input").on("input", function () {
    let newValue = parseInt(
      $(this)
        .val()
        .replace(/[^0-9]/g, ""),
      10,
    );
    if (isNaN(newValue)) {
      newValue = null;
    }
    $(this).val(newValue);
  });
};

const updateBackofficeThirdPartyDataInfo = (tpdQuestions) => {
  const isNewBusiness =
    $("body").data("journey-name") === "backoffice_new_business";

  const scriptSelector = isNewBusiness
    ? ".tpd-pre-pop-new-business-script"
    : ".tpd-pre-pop-non-new-business-script";
  if ($.isEmptyObject(tpdQuestions)) {
    $(".third-party-data-header").addClass("hide");
    $(scriptSelector).addClass("hide");
    $(".tpd-pre-populated").removeClass("tpd-pre-populated");
  } else {
    $(".third-party-data-header").removeClass("hide");
    $(scriptSelector).removeClass("hide");
    Object.keys(tpdQuestions).forEach((question) => {
      $(`[data-question='${question}']`).addClass("tpd-pre-populated");
    });
  }
};

const updateRebuildCostInputState = (
  question,
  enrichedQuestion,
  tpdEnrichedQuestions,
  isBackofficeQuestionnaire,
) => {
  const $questionInput = question.find("input");
  const questionName = question.data("question");
  const canPrepop =
    Object.prototype.hasOwnProperty.call(tpdEnrichedQuestions, questionName) &&
    tpdEnrichedQuestions[questionName] === enrichedQuestion;
  const usingPrepopValue = enrichedQuestion === $questionInput.val();
  const handleSuccessfulTpdFetch = (question) => {
    question
      .find(".js-tpd-formatted-answer")
      .text(enrichedQuestion)
      .unmask()
      .mask("#,##0", { reverse: true });
    question.find(".js-tpd-question").show();
    question.find(".js-tpd-question-manual").hide();
    question.removeClass("hide");
  };

  if (canPrepop && !$questionInput.val()) {
    // we can prepop but haven't yet
    question.addClass("hide");
    if (isBackofficeQuestionnaire) {
      handleSuccessfulTpdFetch(question);
    } else {
      $("#js-rebuild-cost-estimate-tpd-loader-overlay").show();
      setTimeout(() => {
        handleSuccessfulTpdFetch(question);
        $("#js-rebuild-cost-estimate-tpd-loader-overlay").hide();
      }, 800);
    }
  } else if (canPrepop && (usingPrepopValue || isBackofficeQuestionnaire)) {
    handleSuccessfulTpdFetch(question);
  } else {
    // we can't prepop or the prepop value has been edited
    question.find(".js-tpd-question").hide();
    question.find(".js-tpd-question-manual").show();
  }
};

const isThirdPartyRebuildCostView = () => {
  return $(".js-rebuild-cost-estimate-from-tpd:visible").length > 0;
};

export {
  setupRebuildCostInputEvents,
  updateBackofficeThirdPartyDataInfo,
  updateRebuildCostInputState,
  isThirdPartyRebuildCostView,
};
